module.exports = __webpack_public_path__ + "img/balls-portrait-x2.5e31ab3b.jpg";